// src/router/index.js
import Vue from 'vue';
import Router from 'vue-router';

// Import your views
import HomePage from '../views/Home.vue';
import AboutPage from '../views/About.vue';
import FinancialInfo from '../views/FinancialInfo/Info.vue';
import FinancialStatements from '../views/FinancialInfo/Statements.vue';
import FinancialDescription from '../views/FinancialInfo/Description.vue';

import StockPriceInfo from '../views/StockPriceInfo/Info.vue';
import StockPriceRetrospect from '../views/StockPriceInfo/Retrospect.vue';
import StockPriceCalculator from '../views/StockPriceInfo/Calculator.vue';

import BasicInfo from '../views/BasicInfo/Info.vue';
import BasicMajorShareholders from '../views/BasicInfo/MajorShareholders.vue';
import BasicDividendPayment from '../views/BasicInfo/DividendPayment.vue';
import BasicShareholderMeeting from '../views/BasicInfo/ShareholderMeeting.vue';
import BasicShareSubscription from '../views/BasicInfo/ShareSubscription.vue';

import WarrantHoldersInfo from '../views/WarrantHoldersInfo/Info.vue';

import DebtInfo from '../views/DebtInfo/Info.vue';
import DebtCreditRating from '../views/DebtInfo/CreditRating.vue';
import DebtIBillExchange from '../views/DebtInfo/BillExchange.vue';

import NewInfo from '../views/NewInfo/Info.vue';
import NewsMedia from '../views/NewInfo/NewsMedia.vue';
import NewsPrintMedia from '../views/NewInfo/NewsPrintMedia.vue';
import ElectronicAdvertising from '../views/NewInfo/ElectronicAdvertising.vue';

import CalendarInfo from '../views/CalendarInfo/Info.vue';

import PublishedDocsInfo from '../views/PublishedDocsInfo/Info.vue';
import AnnualReport from '../views/PublishedDocsInfo/AnnualReport.vue';
import SustainabilityReport from '../views/PublishedDocsInfo/SustainabilityReport.vue';
import Form56 from '../views/PublishedDocsInfo/Form56-1.vue';
import DownloadDocuments from '../views/PublishedDocsInfo/DownloadDocuments.vue';

import ActivityInfo from '../views/Activity/Info.vue';

import AnalystInfo from '../views/Analyst/Info.vue';
import SecuritiesAnalysis from '../views/Analyst/SecuritiesAnalysis.vue';

import InformationInfo from '../views/Information/Info.vue';
import ReceiveEmails from '../views/Information/ReceiveEmails.vue';

// Use Vue Router with Vue
Vue.use(Router);

// Define your routes
const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomePage,
  },
  {
    path: '/about',
    name: 'About',
    component: AboutPage,
  },

  {
    path: '/financialinfo/info',
    name: 'financialinfo',
    component: FinancialInfo,
  },
  {
    path: '/financialinfo/statements',
    name: 'financialstatements',
    component: FinancialStatements,
  },
  {
    path: '/financialinfo/description',
    name: 'Financialdescription',
    component: FinancialDescription,
  },
  {
    path: '/stockpriceinfo/info',
    name: 'Stockpriceinfo',
    component: StockPriceInfo,
  },
  {
    path: '/stockpriceinfo/retrospect',
    name: 'Stockpriceretrospect',
    component: StockPriceRetrospect,
  },
  {
    path: '/stockpriceinfo/calculator',
    name: 'Stockpricecalculator',
    component: StockPriceCalculator,
  },
  {
    path: '/basicinfo/info',
    name: 'Basicinfo',
    component: BasicInfo,
  },
  {
    path: '/basicinfo/majorshareholders',
    name: 'Basicmajorshareholders',
    component: BasicMajorShareholders,
  },
  {
    path: '/basicinfo/dividendpayment',
    name: 'Basicdividendpayment',
    component: BasicDividendPayment,
  },
  {
    path: '/basicinfo/shareholdermeeting',
    name: 'Basicshareholdermeeting',
    component: BasicShareholderMeeting,
  },
  {
    path: '/basicinfo/sharesubscription',
    name: 'basicsharesubscription',
    component: BasicShareSubscription,
  },
  {
    path: '/warrantholdersinfo',
    name: 'warrantholdersinfo',
    component: WarrantHoldersInfo,
  },
  {
    path: '/debtinfo/info',
    name: 'debtinfo',
    component: DebtInfo,
  },
  {
    path: '/debtinfo/creditrating',
    name: 'creditrating',
    component: DebtCreditRating,
  },
  {
    path: '/debtinfo/billexchange',
    name: 'billexchange',
    component: DebtIBillExchange,
  },
  {
    path: '/newinfo/info',
    name: 'newinfo',
    component: NewInfo,
  },
  {
    path: '/newinfo/newsmedia',
    name: 'newsmedia',
    component: NewsMedia,
  },
  {
    path: '/newinfo/newsprintmedia',
    name: 'newsprintmedia',
    component: NewsPrintMedia,
  },
  {
    path: '/newinfo/electronicadvertising',
    name: 'electronicadvertising',
    component: ElectronicAdvertising,
  },
  {
    path: '/calendarinfo/info',
    name: 'calendarinfo',
    component: CalendarInfo,
  },
  {
    path: '/publisheddocsinfo/info',
    name: 'publisheddocsinfo',
    component: PublishedDocsInfo,
  },
  {
    path: '/publisheddocsinfo/annualreport',
    name: 'annualreport',
    component: AnnualReport,
  },
  {
    path: '/publisheddocsinfo/sustainabilityreport',
    name: 'sustainabilityreport',
    component: SustainabilityReport,
  },
  {
    path: '/publisheddocsinfo/form56-1',
    name: 'form56-1',
    component: Form56,
  },
  {
    path: '/publisheddocsinfo/downloaddocuments',
    name: 'downloaddocuments',
    component: DownloadDocuments,
  },
  {
    path: '/activityinfo',
    name: 'activityinfo',
    component: ActivityInfo,
  },
  {
    path: '/analystinfo',
    name: 'analystinfo',
    component: AnalystInfo,
  },
  {
    path: '/securitiesanalysis',
    name: 'securitiesanalysis',
    component: SecuritiesAnalysis,
  },
  {
    path: '/informationinfo',
    name: 'informationinfo',
    component: InformationInfo,
  },
  {
    path: '/receiveemails',
    name: 'receiveemails',
    component: ReceiveEmails,
  },
];

const router = new Router({
  mode: 'history',
  routes,

  scrollBehavior(to, from, savedPosition) {
    // If the user has a saved position, return it
    if (savedPosition) {
      return savedPosition;
    }

    // Otherwise, scroll to the top of the page
    return { x: 0, y: 0 };
  }
});

export default router;
